import Navigation from '@/components/Navigation/Navigation'
import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router'

export const Route = createFileRoute('/car-navigation')({
  component: CarNavigationLocal,
})

function CarNavigationLocal() {
  const location = useLocation()

  const isExactPath = location.pathname === '/car-navigation' || location.pathname === '/car-navigation/'

  if (isExactPath) {
    return <Navigation vehicleId={undefined} fullscreen={true} />
  }

  return <Outlet />
}
